import { Box } from '@mui/material';
import { leftSideContainerSx } from '../../styles/createCampaign';
import { EmailAlertsAccordion } from './EmailAlertsAccordion';
import { BusinessDetails } from './BusinessDetails';
import { AboutTheBusiness } from './AboutTheBusiness';
import { CampaignNotes } from './CampaignNotes';
import { TermsNConditions } from './TermsNConditions';
import { BusinessImages } from './BusinessImages';

export const ConfirmAndPayLeftSide = ({
  locationDetails
}: {
  locationDetails?: any;
}) => {
  return (
    <Box sx={leftSideContainerSx}>
      <BusinessDetails />

      <AboutTheBusiness locationDetails={locationDetails} />

      <BusinessImages />

      <CampaignNotes />

      <EmailAlertsAccordion />

      <TermsNConditions />
    </Box>
  );
};
